import { createBrowserRouter, Navigate } from "react-router-dom";

import { PrivateRoute } from "@/shared/components/utils/PrivateRoute";
import { PublicRoute } from "@/shared/components/utils/PublicRoute";

import { BranchLayout } from "@/shared/components/layout/BranchLayout";
import { AuthLayout } from "@/shared/components/layout/AuthLayout";
import { LogInPage } from "@/pages/LogInPage/LogInPage";
import { PersonalPage } from "@/pages/PersonalPage/PersonalPage";
import { CatchmentPage } from "@/pages/CatchmentPage";
import { Companies } from "@/pages/CompaniesPage/Companies";
import { Gyms } from "@/pages/Gyms/Gyms";
import { Maintenance } from "@/pages/Maintenance/Maintenance";
import { Inventory } from "@/pages/Inventory/Inventory";
import { ViewStandardLayout } from "@/shared/components/layout/ViewStandardLayout";
import { CampaignPage } from "@/pages/CampaignPage";
import { TaskPage } from "@/pages/TaskPage";
import { RecoveryPage } from "@/pages/RecoveryPage";
import { AssignedPage } from "@/pages/AssignedPage";
import { BillsPage } from "@/pages/BillsPage/BillsPage";
import { Chat } from "@/pages/Chat/Chat";
import { ContratosClausulas } from "@/pages/ContratosClausulasPage/ContratosClausulas";
import { Customization } from "@/pages/CustomizationPages/Customization";
import { DirectedActivities } from "@/pages/DirectedActivities/DirectedActivities";
import { EditNutritionPages } from "@/pages/EditNutritionPages/EditNutritionPages";
import { EditTrainingPages } from "@/pages/EditTrainingPages/EditTrainingPages";
import Test from "@/pages/Ejemplos/test";
import { AccesDenied } from "@/pages/ErrorPages/AccesDenied";
import { PagesNotFound } from "@/pages/ErrorPages/PagesNotFound";
import { Exercises } from "@/pages/Exercises/Exercises";
import { DeviceLinking } from "@/pages/DeviceLinking/DeviceLinking";
import { FAQPage } from "@/pages/FAQPage/FAQPage";
import { FeesPage } from "@/pages/FeesPage/FeesPage";
import { ImpuestosRecibos } from "@/pages/ImpuestosRecibos/ImpuestosRecibos";
import { InformationUserPages } from "@/pages/InformationUserPages/InformationUserPages";
import { InternalChats } from "@/pages/InternalChats/InternalChats";
import { PostInternalChats } from "@/pages/InternalChats/PostInternalChats";
import { LeadBusinessStagePage } from "@/pages/LeadBusinessStagePage";
import { LeadNotePage } from "@/pages/LeadNotePage";
import { LeadPage } from "@/pages/LeadPage";
import { ListUser } from "@/pages/ListUserPages/ListUser";
import { Permissions } from "@/pages/Permissions/Permissions";
import { PersonalInformationNutritionPage } from "@/pages/PersonalInformationPages/PersonalInformationNutritionPage";
import { PersonalInformationPage } from "@/pages/PersonalInformationPages/PersonalInformationPage";
import { PreRecordedClasses } from "@/pages/PreRecordedClasses/PreRecordedClasses";
import RegisterPages from "@/pages/RegisterPages/RegisterPages";
import { ReservaEspacios } from "@/pages/ReservaEspacios/ReservaEspacios";
import { ServiciosProfesionales } from "@/pages/ServiciosProfesionales/ServiciosProfesionales";
import { Courses } from "@/pages/Courses/Courses";
import { CourseFees } from "@/pages/Courses/CourseFees";
import { StorePage } from "@/pages/Store/index";
import { SubscriptionsPage } from "@/pages/SubscriptionsPage/SubscriptionsPage";
import { TabsPage } from "@/pages/Tags/index";
import { TagsUsers } from "@/pages/Tags/TagsUsers";
import KpiPage from "@/pages/Kpis";
import { AbsencesPage } from "@/pages/Kpis/Componennts/AbsencesComponent";
import { AbsencesLessonPage } from "@/pages/Kpis/Componennts/AbsencesLessonsComponent";
import { AbsencesProgram } from "@/pages/Kpis/Componennts/AbsencesProgramComponent";

import { TabsAccountingIntegration } from "@/pages/AccountingIntegration/AccountingIntegration";

import { AdminLayout } from "@/shared/components/layout/AdminLayout";
import { Access } from "@/pages/Access/Access";

import { RootLayout } from "@/shared/components/layout/RootLayout";
import { AccountingPage } from "@/pages/AccountingPage/AccountingPage";
import { TicketPage } from "@/pages/TicketPage";
import { AuthorizedRoute } from "@/shared/components/utils/AuthorizedRoute";
import { Permission } from "@/shared/hooks/usePermission";

import RegisterUser from "@/pages/register/RegisterUser";
import TasksPage from "@/pages/TasksPage";
import Leads from "@/pages/leads/Leads";

import { ProductsPage } from "@/pages/ProductsPage/ProductsPage";
import { DishesPage } from "@/pages/DishesPage/DishesPage";
import { ProtectedGym } from "@/shared/components/utils/ProtectedGym";
import { CampaignRegister } from "@/pages/CampaignPage/CampaignRegister";

export const router = createBrowserRouter([
  {
    path: "",
    element: <Navigate to="/users" replace />,
  },
  {
    path: "/auth",
    element: (
      <PublicRoute onlyPublic>
        <AuthLayout />
      </PublicRoute>
    ),
    children: [
      {
        path: "/auth/login",
        element: <LogInPage />,
      },
    ],
  },
  {
    path: "/register/user",
    element: (
      <PrivateRoute>
        <RootLayout />
        <RegisterUser />
      </PrivateRoute>
    ),
  },
  {
    path: "/campaign/register/user",
    element: (
      <PublicRoute onlyPublic>
        <CampaignRegister />
      </PublicRoute>
    ),
  },
  {
    path: "/branchs",
    element: (
      <PrivateRoute>
        <RootLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: (
          <ProtectedGym>
            <Gyms />
          </ProtectedGym>
        ),
      },
      {
        path: ":id",
        element: <BranchLayout />,
        children: [
          {
            path: "",
            element: <PersonalPage />,
          },
          {
            path: "personal",
            element: (
              <AuthorizedRoute permission={Permission.MULTI_CENTRO}>
                <PersonalPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "accounting",
            children: [
              {
                path: "",
                element: <AccountingPage />,
              },
              {
                path: "bills",
                element: <BillsPage />,
              },
            ],
          },
          {
            path: "store",
            element: <StorePage />,
          },
          {
            path: "maintenance",
            children: [
              {
                path: "",
                element: <Maintenance />,
              },
              {
                path: "inventory",
                element: <Inventory />,
              },
            ],
          },
          {
            path: "events",
            children: [
              {
                path: "directed-activities",
                element: <DirectedActivities />,
              },
              {
                path: "professional-services",
                element: <ServiciosProfesionales />,
              },
              {
                path: "spaces",
                element: <ReservaEspacios />,
              },
              {
                path: "courses",
                element: <Courses />,
              },
              {
                path: "course-fee",
                element: <CourseFees />,
              },
              {
                path: "pre-recorded-classes",
                element: <PreRecordedClasses />,
              },
            ],
          },
          {
            path: "fees",
            element: <FeesPage />,
          },
          {
            path: "marketing",
            children: [
              {
                path: "chat",
                element: <InternalChats />,
              },
              {
                path: "posts",
                element: <PostInternalChats />,
              },
              {
                path: "captation",
                element: <CatchmentPage />,
              },
              {
                path: "captation/tasks",
                element: <TasksPage />,
              },
              {
                path: "campaigns",
                element: <CampaignPage />,
              },
              {
                path: "recovery",
                element: <RecoveryPage />,
              },
            ],
          },
          {
            path: "settings",
            children: [
              {
                path: "authorization",
                element: <Permissions />,
              },
              {
                path: "subscriptions",
                element: <SubscriptionsPage />,
              },
              {
                path: "invoices",
                element: <ImpuestosRecibos />,
              },
              {
                path: "contracts",
                element: <ContratosClausulas />,
              },
              {
                path: "exercises",
                element: <Exercises />,
              },
              {
                path: "device-linking",
                element: <DeviceLinking />,
              },
              {
                path: "accounting-integration",
                element: <TabsAccountingIntegration />,
              },
              {
                path: "customization",
                element: <Customization />,
              },
              {
                path: "marketing-tags",
                element: <TabsPage />,
              },
              {
                path: "user-tags",
                element: <TagsUsers />,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/",
    element: (
      <PrivateRoute>
        <ViewStandardLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "kpis",
        children: [
          {
            path: "",
            element: (
              <AuthorizedRoute permission={Permission.ACCESS_KPI}>
                <KpiPage />
              </AuthorizedRoute>
            ),
          },
          {
            path: "absences",
            element: <AbsencesPage />,
          },
          {
            path: "absences-lessons",
            element: <AbsencesLessonPage />,
          },
          {
            path: "absences-program",
            element: <AbsencesProgram />,
          },
        ],
      },
      {
        path: "gyms",
        element: (
          //<AuthorizedRoute permission={Permission.COMPANY_ACCESS}>
          <Companies />
          //</AuthorizedRoute>
        ),
      },
      {
        path: "users",
        element: <ListUser />,
      },
      {
        path: "users/:id",
        element: <InformationUserPages />,
      },
      {
        path: "leads/:id",
        element: <Leads />,
      },
      {
        path: "assigned",
        element: <AssignedPage />,
      },
      {
        path: "access",
        element: <Access />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "faq",
        element: <FAQPage />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <PrivateRoute>
        <RootLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "training",
        element: <EditTrainingPages />,
      },
      {
        path: "nutrition",
        element: <EditNutritionPages />,
      },
      {
        path: "tickets",
        element: <TicketPage />,
      },
      {
        path: "tasks",
        element: <TasksPage />,
      },
      {
        path: "nutrition/dishes",
        element: <DishesPage />,
      },
      {
        path: "nutrition/products",
        element: <ProductsPage />,
      },
      {
        path: "admin",
        element: <ViewStandardLayout />,
        children: [
          {
            path: "campaigns",
            element: <CampaignPage />,
          },
          {
            path: "tasks",
            element: <TaskPage />,
          },
        ],
      },
      {
        path: "leads",
        children: [
          {
            path: "tasks",
            element: <LeadPage />,
          },
          {
            path: "notes",
            element: <LeadNotePage />,
          },
          {
            path: "business-stage",
            element: <LeadBusinessStagePage />,
          },
        ],
      },
      {
        path: "brand",
        element: <BranchLayout />,
        children: [
          {
            path: "InternalChats",
            element: <InternalChats />,
          },
          {
            path: "InternalChats/posts-masters",
            element: <PostInternalChats />,
          },
        ],
      },
      {
        path: "test",
        element: <Test />,
      },
    ],
  },
  {
    path: "admin",
    element: (
      <PrivateRoute>
        <AdminLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "user/p-customize/edit",
        element: <EditTrainingPages />,
      },
      {
        path: "users/p-customize-nutrition/edit",
        element: <EditNutritionPages />,
      },
      {
        path: "register/app/new",
        element: <RegisterPages />,
      },
      {
        path: "register/personal-information/new",
        element: <PersonalInformationPage />,
      },
      {
        path: "register/personal-information-nutricionista",
        element: <PersonalInformationNutritionPage />,
      },
    ],
  },
  {
    path: "test2",
    element: <AccesDenied />,
  },
  {
    path: "*",
    element: <PagesNotFound />,
  },
]);
